<template>
  <div id="app">
    <el-container class="first">
      <el-header v-if="login" :class="{'full-main': fullPage}" height="auto">
        <paca-header></paca-header>
      </el-header>
      <el-container class="second" :class="[{'unLogin': !login}, {'full-main': fullPage}]">
        <el-aside v-if="path.indexOf('/login') == -1" width="auto">
          <paca-aside></paca-aside>
        </el-aside>
        <el-main :key="routerKey" :class="{'is-full': asideCollapseButton && !routeLogin}">
          <keep-alive>
            <router-view />
          </keep-alive>
        </el-main>
      </el-container>
      <el-footer height="auto" :class="{'full-main': fullPage}">
        <paca-footer></paca-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import '@/style/reset/reset.css'
import pacaHeader from '@/components/header/header.vue'
import pacaAside from '@/components/aside/aside.vue'
import pacaFooter from '@/components/footer/footer.vue'
export default {
  name: 'app',
  data(){
    return{
      email: '',
      password: '',
      routerKey: 0
    }
  },
  components: {
    pacaHeader,
    pacaAside,
    pacaFooter
  },
  methods: {
    switchLanguage(language){
      switch(language){
        case 'zh-TW': 
          this.$i18n.locale = 'zh-TW';
          break
        case 'en':
          this.$i18n.locale = 'en';
          break
        default:
          this.$i18n.locale = 'zh-TW';
          break
      }
    }
  },
  computed: {
    login(){
      return this.$store.state.userInfo
    },
    path(){
      return this.$route.path
    },
    routeLogin(){
        return this.$route.path.indexOf('login')!='-1'?true:false
    },
    routePublic(){
      return this.$route.path.indexOf('public')!='-1'?true:false
    },
    asideCollapseButton(){
        return this.$store.state.asideCollapseButton
    },
    fullPage(){
      return this.$store.state.fullPage
    }
  },
  watch: {
    routeLogin(){
        if(this.$route.path.indexOf('login') != -1){
            this.routerKey += 1;
        }
    }
  },
  activated(){
    let htmlTag = document.getElementsByTagName('html')[0];
    let language = (navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage);
    if(language != 'zh-TW'){
      language = 'en';
    }
    htmlTag.setAttribute('lang', language);
    this.$i18n.locale = language;
  }
}
</script>